export const ALLOWED_CURRENCIES = ['USD', 'EUR', 'INR', 'IDR'] as const

export function normalizeDisplayCurrency(code: string | undefined): string {
  const c = String(code || 'USD').toUpperCase()
  return (ALLOWED_CURRENCIES as readonly string[]).includes(c) ? c : 'USD'
}
